import React from 'react';

export const Database: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33334 12C3.33334 12.9207 5.42268 13.6667 8.00001 13.6667C10.5773 13.6667 12.6667 12.9207 12.6667 12V4.00001C12.6667 3.07934 10.5773 2.33334 8.00001 2.33334C5.42268 2.33334 3.33334 3.07934 3.33334 4.00001V12Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 4C12.6667 4.92067 10.5773 5.66667 8.00001 5.66667C5.42268 5.66667 3.33334 4.92067 3.33334 4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 9.33334C12.6667 10.254 10.5773 11 8.00001 11C5.42268 11 3.33334 10.254 3.33334 9.33334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 6.66669C12.6667 7.58735 10.5773 8.33335 8.00001 8.33335C5.42268 8.33335 3.33334 7.58735 3.33334 6.66669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
